// Hook pobierajacy szczegoly koszyka do akceptacji

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IResponse {
  id: number;
  name: string | null;
  status: number | null;
  create_datetime: string | null;
  status_change_date: string | null;
  currency: string | null;
  value_net: number | null;
  value_gross: number | null;
  user_id: number | null;
  client_id: number | null;
  approver_user_id: number | null;
  approval_notice: string | null;
}

const getCartToApprove = (id: number): Promise<IResponse> => axios.get(`/carts-to-approve/${id}`);

export const useGetCartToApprove = (id: number, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['cart-to-approve', id], () => getCartToApprove(id), options);
